<template lang="pug">
    v-layout(wrap)
        v-flex(xs12)
            m-list(v-bind="$attrs" v-on="$listeners" title="")
                template(#title="")
                    slot(name="title" v-if="$slots.title")
                    template(v-else) {{$t(`modules.lists.${name}.subheading`, {num: $attrs.pagination.totalItems})}}

                template(#template="{item, index}")
                    m-card-user(:item="item" :key="`${index}-${item.firstName}`")
</template>

<script>
    import MCardUser from "@modules/cards/concrete/m-card-user";
    import baseList from "@mixins/components/modules/lists/base";

    let name = 'm-list-users';
    export default {
        name: name,
        mixins: [baseList],
        components: {MCardUser},
        props: {
            name: {
                type: String,
                default: name
            }
        }
    }
</script>

<style lang="scss" scoped>
    //
</style>
